var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pcShare-container"},[(_vm.isPC)?_c('pcShareMenu',{staticClass:"pcShare-menu"}):_vm._e(),_c(_vm.activeType,{ref:_vm.type,tag:"component",attrs:{"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }